import { render, staticRenderFns } from "./releaseFailEdit.vue?vue&type=template&id=101cda84&scoped=true"
import script from "./releaseFailEdit.vue?vue&type=script&lang=js"
export * from "./releaseFailEdit.vue?vue&type=script&lang=js"
import style0 from "./releaseFailEdit.vue?vue&type=style&index=0&id=101cda84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "101cda84",
  null
  
)

export default component.exports